module.exports = __webpack_public_path__ + "media/images/JemTheMovie/web_twitter_icon_x100-3d5add4667e458d688792690f66326f2.png";